// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"css-2VTD600F4-"};